import React, { PropTypes, Component } from 'react'
import { toggleOverlay } from '../../../store/reducers';
import {connect} from 'react-redux';
import Arrow from 'react-icons/lib/io/android-arrow-forward';
import ZoomIn from 'react-icons/lib/md/zoom-in';
import ZoomOut from 'react-icons/lib/md/zoom-out';
import Close from 'react-icons/lib/md/close';
import style from './style.css';

class ImageViewer extends Component {

    constructor(props){
        super(props)
        this.state = { zoomed: false }
        this.previous =  this.previous.bind(this)
        this.next =  this.next.bind(this)
        this._toggleZoom = this._toggleZoom.bind(this)
    }

    previous(){
        if(this.state.zoomed){ this._toggleZoom(); }
        this.props.previous();
    }
    next(){
        if(this.state.zoomed){ this._toggleZoom(); }
        this.props.next();
    }

    _toggleZoom(status=null){
        this.setState({ ...this.state, zoomed: status===null ? !this.state.zoomed : status })
    }

    _close_overlay(){
        this.props._toggle_overlay(false);
    }

    componentWillUnmount() {
        this._close_overlay();
    }

    render() {
        const { current, count, next, previous, photo } = this.props
        const photo_uri = photo ? photo().src : null
        console.log("Current_photo: " + current)
        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const windowWidth = "innerWidth" in window ? window.innerWidth : document.documentElement.offsetWidth;
        return (
            <div className={ style.container } style={{ height: windowHeight, width: windowWidth}}>
                <div className={ style.count }> { current + 1 } / { count }</div>
                <div className={ style.close }> <Close onClick={ this.props.close } /> </div>
                <div className={ style.iconBar }>
                    <div className={ style.previous }> <Arrow onClick={ () => { this.previous() }} /> </div>
                    <div className={ style.zoomIcons }>
                        <div className={ style.zoomInIcon }> <ZoomIn  onClick={ () => { this._toggleZoom(true) }} /> </div>
                        <div className={ style.zoomOutIcon }> <ZoomOut onClick={ () => { this._toggleZoom(false) }} /> </div>
                    </div>
                    <div className={ style.next }> <Arrow onClick={ () => { this.next() } } /> </div>
                </div>
                <div className={ style.inner }>
                    <img src={ photo_uri && photo_uri.replace(/large|medium/, "gallery") } className={ [ style.img, this.state.zoomed ? style.zoomIn : style.zoomOut ].join(" ") } onClick={ () => { this._toggleZoom() }}/>
                </div>
            </div>
        )
    }
}
export default connect( 
    state =>({
        overlay: state.app.overlay,
    }),
    dispatch => { 
    return { 
        _toggle_overlay: (payload) => { dispatch(toggleOverlay(payload)) } ,
    } 
    }
)(ImageViewer);



// WEBPACK FOOTER //
// ./src/components/pagescreen/imageviewer/index.js